import React, { FC } from 'react';

export const ProfileResumeTitle: FC = (props) => (
  <h1 className="font-medium text-ink dark:text-ink-dark">{props.children}</h1>
);
export const ProfileResumeSubtitle: FC = (props) => (
  <h1 className="text-inkMuted dark:text-inkMuted-dark ellipsis text-sm font-medium mb-3">
    {props.children}
  </h1>
);

// Mapa explícito de clases completas: Tailwind no puede generar clases
// compuestas a partir de un template literal con un valor recibido en
// runtime (`bg-${color}-100`), así que cada color soportado necesita su
// propia entrada literal acá.
const badgeColorClasses: Record<string, string> = {
  green:
    'bg-emerald-100 text-emerald-700 dark:bg-emerald-500/20 dark:text-emerald-300',
  red: 'bg-red-100 text-red-700 dark:bg-red-500/20 dark:text-red-300'
};

export const ProfileResumeBadge: FC<{ color: string }> = ({
  children,
  color
}) => (
  <span
    className={`rounded-md font-semibold text-center text-xs px-2 py-1 ${
      badgeColorClasses[color] ??
      'bg-secondary-100 text-secondary-700 dark:bg-white/10 dark:text-secondary-200'
    }`}
  >
    {children}
  </span>
);

const ProfileResumeContainer: FC = (props) => {
  return <div className="overflow-hidden ml-2">{props.children}</div>;
};

export default ProfileResumeContainer;
